export const PASSWORD_REQUIREMENT_MESSAGE =
    "パスワードは8文字以上で、英字・数字・記号をそれぞれ1文字以上含めてください。";

const USABLE_SYMBOLS = `!"#$%&'()*+,-./:;<=>?@[]^_\`{|}~`;

export function getPasswordValidationMessage(
    password: string,
    required = true
): string | null {
    if (password.length === 0) {
        return required ? PASSWORD_REQUIREMENT_MESSAGE : null;
    }

    const containsOnlyUsableCharacters = Array.from(password).every(
        (character) =>
            /[A-Za-z0-9]/.test(character) || USABLE_SYMBOLS.includes(character)
    );

    if (
        password.length < 8 ||
        !/[A-Za-z]/.test(password) ||
        !/[0-9]/.test(password) ||
        !Array.from(password).some((character) => USABLE_SYMBOLS.includes(character)) ||
        !containsOnlyUsableCharacters
    ) {
        return PASSWORD_REQUIREMENT_MESSAGE;
    }

    return null;
}